
/* 定义动态加载 JS、CSS、JSON、Text 的方法 */
const loaders = (function () {
    var scripts = {}; //js 文件的加载状态

    //加载文件/创建组件
    //
    //   path     - 文件路径/组件名称
    //
    //   callback - 加载/创建完成后执行的回掉函数，原型：
    //                 void callback(compn, succ, path);
    //                     compn - 成功时，为创建的组件实例；失败时，为错误消息。
    //                     succ  - 是否加载/创建成功
    //                     path  - 文件路径/组件名称
    //
    //   scop     - 执行 callback 回掉时，重定向 this 指针
    //
    //   factory  - 当组件不存在时，执行此工厂函数来加载/创建组件，原型：
    //                 object factory(path, cb);
    //                 参数：
    //                      path  - 文件路径/组件名称
    //                      cb    - 组件加载或创建完成后，需调用此函数来告知结果，原型：
    //                                  void cb(compn,succ);
    //                                      compn - 成功时，为创建的组件实例；失败时，为错误消息。
    //                                      succ  - 是否加载/创建成功
    //
    function _load(path, callback, scop, factory) {
        var info = scripts[path];
        if (!info) {
            info = { status: "none", onloaded: [], compn: null, path: path };
            scripts[path] = info;
        }

        if (info.status === "loaded") {
            callback.apply(scop || this, [info.compn, true, info.path]);
            return;
        } else if (info.status === "failed") {
            callback.apply(scop || this, [info.compn, false, info.path]);
            return;
        }

        info.onloaded.push({
            scop: scop,
            cb: callback
        });

        if (info.status === "none") {
            info.status = "loading";
            factory(path, function (compn, succ) {
                info.status = succ ? "loaded" : "failed";
                info.compn = compn;
                for (var i = 0; i < info.onloaded.length; i++) {
                    var cbInfo = info.onloaded[i];
                    if (typeof cbInfo.cb === "function") {
                        cbInfo.cb.apply(cbInfo.scop || this, [compn, succ, info.path]);
                    }
                }
                info.onloaded = [];
                delete info.onloaded;
            });
        }
    }

    //加载文件
    //
    //   path     - 文件路径
    //
    //   callback - 加载完成后执行的回掉函数，原型：
    //                 void callback(compn, succ, path);
    //                     compn - 成功时，为创建的组件实例；失败时，为错误消息。
    //                     succ  - 是否加载/创建成功
    //                     path  - 文件路径/组件名称
    //
    //   scop     - 执行 callback 回掉时，重定向 this 指针
    //
    //   factory  - 当文件未加载时，执行此工厂函数来加载文件，原型：
    //                 object factory(path);
    //                 参数：
    //                      path  - 文件路径
    //
    function loadFile(path, factory) {
        return new Promise(function (resolve, reject) {
            _load(
                path,
                function(compn, succ, path) {
                    if (succ) {
                        resolve(compn);
                    }
                    else {
                        reject('Failed to load ' + path);
                    }
                },
                this,
                function (path, cb) {
                    var elem = factory(path);
                    //不支持 IE9 以下的版本
                    elem.onload = elem.onerror = function (e) {
                        elem.onload = null;
                        elem.onerror = null;
                        cb.apply(this, [this, e.type === "load"]);
                    };
                    document.body.appendChild(elem);
                });
        });
        
    }

    //加载脚本文件
    //
    //   path     - 文件路径
    //
    function loadScript(path) {
        return loadFile(path, function (path) {
            var script = document.createElement("script");
            script.type = "text/javascript";
            script.src = path;
            return script;
        });
    }

    //加载样式文件
    function loadCss(path) {
        return loadFile(path, function (path) {
            var link = document.createElement("link");
            link.rel = "stylesheet";
            link.href = path;
            return link;
        });
    }

    return {
        loadFile,
        loadScript,
        loadCss
    };

})();

export default loaders;
